import { axiosJSONInstance } from '@/config';
import { BulkDelayRtoPayload, BulkResendPayload, ResendPayload, ResendResponse } from '@/types/inventory';

export const fetchInventoryOrders = async (page: number, perPage: number) => {
  const response = await axiosJSONInstance.get('/merchants/inventory', {
    params: { page, perpage: perPage },
  });
  return response.data;
};

export const resendOrder = async (uid: string, payload: ResendPayload): Promise<ResendResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/inventory/${uid}/resend`, payload);
  return response.data;
};

export const delayRtoOrder = async (uid: string, reason?: string) => {
  const response = await axiosJSONInstance.post(`/merchants/inventory/${uid}/delay-rto`, {
    reason,
  });
  return response.data;
};

export const bulkResendOrders = async (payload: BulkResendPayload) => {
  const response = await axiosJSONInstance.post('/merchants/inventory/bulk-resend', payload);
  return response.data;
};

export const bulkDelayRtoOrders = async (payload: BulkDelayRtoPayload) => {
  const response = await axiosJSONInstance.post('/merchants/inventory/bulk-delay-rto', payload);
  return response.data;
};
